import { makeStyles } from '@material-ui/styles'

export const useStudentListNameAgeStyles = makeStyles(theme => ({
  row: {
    cursor: 'pointer',
  },
  info: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    minWidth: 0,
  },
  nameCell: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    minWidth: 0,
  },
  studentAvatar: {
    height: '36px',
    width: '36px',
    flexShrink: 0,
    backgroundColor: '#EBF0F2',
    color: '#172024',
    fontSize: '13px',
    fontWeight: 500,
  },
  text: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.15px',
    textAlign: 'left',
  },
  ageGroupChip: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 9999,
    padding: '2px 8px',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '16px',
    whiteSpace: 'nowrap',
  },
  ageGroupChipJunior: {
    backgroundColor: '#EBF0F2',
    color: '#172024',
  },
  ageGroupChipAdult: {
    backgroundColor: '#E0EAFF',
    color: '#001C57',
  },
}))
